module.exports = __webpack_public_path__ + "static/StudentSports-3f19ecc15a9f8e10691dc8b74377916e.jpg";